import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TabNavigationContextType {
  isInsideModal: boolean;
  setIsInsideModal: (value: boolean) => void;
}

const TabNavigationContext = createContext<TabNavigationContextType>({
  isInsideModal: false,
  setIsInsideModal: () => {},
});

export const useTabNavigation = () => {
  const context = useContext(TabNavigationContext);
  return context;
};

interface TabNavigationProviderProps {
  children: ReactNode;
  isModal?: boolean;
}

export const TabNavigationProvider: React.FC<TabNavigationProviderProps> = ({ 
  children, 
  isModal = false 
}) => {
  const [isInsideModal, setIsInsideModal] = useState(isModal);

  return (
    <TabNavigationContext.Provider value={{ isInsideModal, setIsInsideModal }}>
      {children}
    </TabNavigationContext.Provider>
  );
};
